
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'transferaccountsIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-switch style="padding-left:20px" v-model={this.showUnsendjindie} onChange={this.showUnsendjindieChange} active-text="显示未同步" inactive-text=""></el-switch>,
				// <el-switch style="padding-left:20px" v-model={this.showOffset} onChange={this.offsetChange} active-text="显示冲抵预收款" inactive-text=""></el-switch>,
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				showUnsendjindie:false,
				moduleName: 'transferaccounts',
				windowName: '普通转账',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			showUnsendjindieChange(e){
				this.foreingKey.unsendjindie = e?1:0
				this.customreload()
			},
			beforeCreateGrid(formConfig,columns,gridOptions){
				gridOptions.checkboxConfig = null
				columns.unshift({
						type: 'checkbox',
						title: '',
						field:'',
						fixed:'left',
						width:50
				})
				columns.forEach((item)=>{
					if(item.field=='jindietype'){
						item.slots = {
							default: ({row,column}) => {	
								let str= []
								if(row.jindierequire){
									let buff = this.checkjindierequire(row)
									if(buff){
										str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">星</el-tag>)
									}else{
										str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">星</el-tag>)
									}
									
								}
								str.push(<span>{column.formatter({row:row})}</span>)
								return str
							}
						}
					}
				})
			},
			checkjindierequire(row){
				let data = row.jindierequire
				
				let buff = true
				if(!data.main){
					buff = false
					return buff
				}
				if(row.jindietype == 'CN_BANKTRANSBILL'){
					if(!data.main.FFROMBANKACNTID_FNumber || !data.main.FTOBANKACNTID_FNumber || !data.main.FEXPLANATION){
						buff = false
					}
				}
				if(row.jindietype == 'CN_CASHTRANSBILL'){
					if(!data.main.FOUTCASHACCTID_FNumber || !data.main.FINCASHACCTID_FNumber){
						buff = false
					}
				}
				if(row.jindietype == 'CN_CASHACCESSBILL'){
					if(!data.main.FBillTypeID || !data.main.FBANKACNTID_FNumber || !data.main.FCashAccount_FNumber){
						buff = false
					}
				}
				if(row.jindietype == 'AP_PAYBILL'){
					if(!data.main.FCONTACTUNITTYPE || !data.main.FCONTACTUNIT_FNumber || !data.main.FACCOUNTID_FNumber){
						buff = false
					}
					data.transferaccounts_detail.forEach((item)=>{
						if(!item.FPURPOSEID_FNumber || !item.FSETTLETYPEID_FNumber){
							buff = false
						}
					})					
				}
				if(row.jindietype == 'AR_RECEIVEBILL'){
					if(!data.main.FPAYUNITTYPE || !data.main.FPAYUNIT_FNumber || !data.main.FACCOUNTID_FNumber || !data.main.FSALEDEPTID_FNumber){
						buff = false
					}
					data.transferaccounts_detail.forEach((item)=>{
						if(!item.FPURPOSEID_FNumber || !item.FSETTLETYPEID_FNumber){
							buff = false
						}
					})
					
				}
				return buff
			},
			sendjindie(){
				let data =  this.getGrid().getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				this.loading = true
				let ids = data.map((item)=>{
					return item.id
				})
				this.$api.transferaccounts.sendjindie({ids:ids}).then(()=>{
					this.loading = false
					this.customreload()
				},()=>{
					this.loading = false
				})
				
			},
		},
		components: {
			
		}
	}
</script>
